/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { ToolbarComponent } from './toolbar';
export * from './toolbar-constants';
export * from './toolbar';
export function defineToolbarComponent() {
    defineCustomElement(ToolbarComponent);
}
